import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'

interface MobileNavItemProps {
	label: string
	href: string
	className?: string
}

export function MobileNavItem({ label, href, className }: MobileNavItemProps) {
	const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		// Check if the href is an anchor link
		if (href.startsWith('#')) {
			e.preventDefault()
			const targetId = href.substring(1)
			const targetElement = document.getElementById(targetId)

			if (targetElement) {
				targetElement.scrollIntoView({ behavior: 'smooth' })
			}
		}
	}

	return (
		<Link
			to={href}
			onClick={handleClick}
			className={cn(
				'flex w-full cursor-pointer items-center rounded-md p-2 font-medium text-muted-foreground hover:text-foreground',
				className
			)}>
			{label}
		</Link>
	)
}
